<template>
  <div class="content fix-height" @click="toggleSidebar">
    <div class="container-fluid">
      <div class="row">

        <div class="col-12">
          <card class="card-plain">
            <div class="table-responsive">
              <table class="table">
                <!-- <thead>
                  <tr>
                    <th v-for="column in table2.columns" :key="column">{{ column }}</th>
                  </tr>
                </thead> -->
                <tbody>
                  <tr v-for="(row, index ) in notifications" :key="row.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ row.content }}</td>
                    <td>{{ row.exp.title }}</td>
                    <td>{{ Math.floor(Math.abs(new Date() - new Date(row.created_at)) / 36e5) }} hours ago</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </card>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import LTable from 'src/components/Table.vue'
import Card from 'src/components/Cards/Card.vue'
import axios from 'axios';
import { Apis } from 'src/constants';

const tableColumns = ['Id', 'Name', 'Salary', 'Country', 'City']
const tableData = [{
  id: 1,
  name: 'Dakota Rice',
  salary: '$36.738',
  country: 'Niger',
  city: 'Oud-Turnhout'
},
{
  id: 2,
  name: 'Minerva Hooper',
  salary: '$23,789',
  country: 'Curaçao',
  city: 'Sinaai-Waas'
},
{
  id: 3,
  name: 'Sage Rodriguez',
  salary: '$56,142',
  country: 'Netherlands',
  city: 'Baileux'
},
{
  id: 4,
  name: 'Philip Chaney',
  salary: '$38,735',
  country: 'Korea, South',
  city: 'Overland Park'
},
{
  id: 5,
  name: 'Doris Greene',
  salary: '$63,542',
  country: 'Malawi',
  city: 'Feldkirchen in Kärnten'
}]
export default {
  components: {
    LTable,
    Card
  },
  data() {
    return {
      table2: {
        columns: [...tableColumns],
        data: [...tableData]
      },
      notifications: []
    }
  },
  mounted() {
    axios.get(Apis.get_notifications, {
      withCredentials: true
    }).then(response => {
      this.notifications = response.data;
    }).catch(error => {
      console.log(error);
    });
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
  }
}
</script>
<style>
.fix-height {
  min-height: 98vh;
}
</style>
